import React from 'react'
// Components
import NavBar from './NavBar';
import CarouselPage from './CarouselPage';
import About from './About';
import JoinOurTeam from './joinOurTeam'
import HealthcareBrochures from './HealthcareBrochures'
import Footer from './Footer'
import ClientSlider from './ClientSlider';


//ChatBot imports
// import ChatBot from './ChatBot/Chatbot'
import ProductPortfolio from './ProductProtfolio';
// import AdminPanel from './ChatBot/AdminPanel'
const Home = () => {
  return (
    <>     
    
           <NavBar />
            <CarouselPage />
            {/* <AdminPanel /> */}
            {/* <ChatBot /> */}
            <About />
            <ProductPortfolio />
            <ClientSlider />
            <JoinOurTeam />
            <HealthcareBrochures />
            <Footer />
        
    
    </>
  )
}

export default Home